export const filter = {
  name: '',
  parent_id: '',
};